import { render, staticRenderFns } from "./ProjectsIssueStatisticsFilter.vue?vue&type=template&id=c0471a8e&scoped=true&"
import script from "./ProjectsIssueStatisticsFilter.vue?vue&type=script&lang=js&"
export * from "./ProjectsIssueStatisticsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0471a8e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
